<template>
  <div :id="componentId" class="sp2-module-6" :style="moduleStyle">
    <div class="sp2-module-6-content">
      <div class="sp2-card-grid">
        <div
          v-for="(item, index) in displayList"
          :key="index"
          class="sp2-card-item"
        >
          <div class="sp2-card-header">
            <div class="sp2-card-title">{{ item.title || '标题' }}</div>
          </div>
          <div class="sp2-card-body">
            <div class="sp2-card-bar" />
            <div class="sp2-card-subtitle">{{ item.subtitle || '副标题' }}</div>
            <div class="sp2-card-meta">
              <div class="sp2-card-meta-item">
                <div class="sp2-card-label">发布时间</div>
                <div class="sp2-card-time">{{ item.publishTime1 || '8月—11月' }}</div>
              </div>
              <div class="sp2-card-meta-item">
                <div class="sp2-card-label">发布时间</div>
                <div class="sp2-card-time">{{ item.publishTime2 || '12月20日' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const FIXED_DATA = [
  {
    title: '一场发展远鉴趋势论坛',
    subtitle: '2026区域农业品牌发展论坛',
    imageUrl: '',
    publishTime1: '8月—11月',
    publishTime2: '12月20日'
  },
  {
    title: '一场沉浸式品鉴体验节',
    subtitle: '一部权威年度发展报告',
    imageUrl: '',
    publishTime1: '12月18日',
    publishTime2: '12月19日-20日'
  },
  {
    title: '一场发展远鉴趋势论坛',
    subtitle: '2026区域农业品牌发展论坛',
    imageUrl: '',
    publishTime1: '8月—11月',
    publishTime2: '12月20日'
  },
  {
    title: '一场发展远鉴趋势论坛',
    subtitle: '2026区域农业品牌发展论坛',
    imageUrl: '',
    publishTime1: '8月—11月',
    publishTime2: '12月20日'
  }
]

export default {
  name: 'SpTwoModule6',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_6'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      list: FIXED_DATA.map(item => ({ ...item }))
    }
  },
  computed: {
    displayList() {
      return (this.list || []).slice(0, 4)
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      }
    }
  }
}
</script>

<style scoped>
.sp2-module-6 {
  position: relative;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-6-content {
  width: calc(100% - 24px);
  margin: 0 auto;
  padding: 24px 0;
  box-sizing: border-box;
}

.sp2-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
}

.sp2-card-item {
  display: flex;
  flex-direction: column;
  background: #F3F6F3;
  border-radius: 10px;
  overflow: hidden;
}

.sp2-card-header {
  display: flex;
  align-items: center;
  min-height: 64px;
  padding: 12px;
  background: linear-gradient(90deg, #5E8BDF 0%, rgba(37, 78, 191, 0) 100%);
  box-sizing: border-box;
}

.sp2-card-title {
  font-size: 15px;
  color: #FFFFFF;
  line-height: 1.4;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.sp2-card-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 12px;
  box-sizing: border-box;
}

.sp2-card-bar {
  width: 28px;
  height: 5px;
  background: linear-gradient(90deg, #1F48BC 0%, #6592E3 100%);
  border-radius: 3px;
  margin-bottom: 10px;
}

.sp2-card-subtitle {
  flex: 1;
  font-size: 14px;
  color: #000000;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 12px;
}

.sp2-card-meta {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.sp2-card-meta-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.sp2-card-label {
  font-size: 11px;
  color: #999999;
  line-height: 1.4;
}

.sp2-card-time {
  font-size: 12px;
  color: #1F48BC;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
